import {
  FETCH_TODAY_AUDIT_TRAIL_SUCCESS,
  FETCH_ALL_AUDIT_TRAIL_SUCCESS,
  FETCH_AUDIT_TRAIL_ACTIONS_SUCCESS,
} from "../ActionTypes";

const INIT_STATE = {
  todaysAudit: [],
  allAudit: {},
  allAuditActions: [],
};

const auditReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TODAY_AUDIT_TRAIL_SUCCESS: {
      return {
        ...state,
        todaysAudit: action.payload,
      };
    }
    case FETCH_ALL_AUDIT_TRAIL_SUCCESS: {
      return {
        ...state,
        allAudit: action.payload,
      };
    }
    case FETCH_AUDIT_TRAIL_ACTIONS_SUCCESS: {
      return {
        ...state,
        allAuditActions: action.payload,
      };
    }
    default:
      return state;
  }
};

export default auditReducer;
